import React, { Component } from "react";
import { Sidebar } from "primereact/sidebar";
import { Menu } from "primereact/menu";
import { Button } from "primereact/button";
import { withRouter } from "react-router";
import { withContext } from "../shared/withContext";
import { Toast } from "primereact/toast";
import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import { ContextIF } from "../../App";
import { isAllreadyReviewed } from "../../parameter";
interface State {
  visible: boolean;
}
interface Props {
  context: ContextIF;
  history: any;
}
class SidebarContainer extends Component<Props, State> {
  state = {
    visible: false,
  };
  toast: any;

  render() {
    let items = [
      {
        label: "Stimmgerät",
        icon: "pi pi-fw pi-arrow-right",
        command: (event: any) => {
          this.setState({ visible: false });
          this.props.history.push("/");
        },
      },
    ];
    isAllreadyReviewed &&
      items.push({
        label: this.props.context.hasPremium
          ? "Abonnement verwalten"
          : "Zur Vollversion wechseln",
        icon: "pi pi-star",
        command: (e) => {
          this.setState({ visible: false });

          this.props.history.push("/premium");
        },
      });

    if (this.props.context.authenticated) {
      items.push({
        label: "Logout",
        icon: "pi pi-sign-out",
        command: (e) => {
          firebase.auth().signOut();
          this.setState({ visible: false });
          this.toast?.show({
            severity: "success",
            summary: "Ausgeloggt",
            detail: "Sie wurden erfolgreich Ausgeloggt",
          });
          window.location.reload();
        },
      });
    } else {
      items.push({
        label: "Login",
        icon: "pi pi-sign-out",
        command: (e) => {
          this.props.history.push("/login");
          this.setState({ visible: false });
        },
      });
    }

    items.push({
      label: "Rohdemusik.de",
      icon: "pi pi-external-link",
      command: (e) => {
        window.location.assign("https://rohdemusik.de");
      },
    });

    items.push({
      label: "Datenschutzerklärung",
      icon: "pi",
      command: (e) => {
        // leite auf rohdemusik.de/privacy-policy weiter
        window.location.assign("https://rohdemusik.de/privacy-policy/");
      },
    });

    return (
      <>
        <Toast ref={(el) => (this.toast = el)} />
        <Button
          icon="pi pi-bars"
          className="p-button-rounded"
          onClick={() => this.setState({ visible: true })}
        />
        <br></br>
        <Sidebar
          visible={this.state.visible}
          onHide={() => this.setState({ visible: false })}
          className="w-100"
        >
          <Menu model={items} className="w-100" />
          <small>v.97</small>
        </Sidebar>
      </>
    );
  }
}
export const SidebarContainerWithoutContext = SidebarContainer;
export default withRouter(withContext(SidebarContainer));
